import { COLORS } from "@/constants";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import styled from "styled-components";

export const StyledFormGroup = styled(FormGroup)`
  &.MuiFormGroup-root {
    justify-content: center;
    & .MuiFormControlLabel-root {
      margin-left: 0;
      margin-right: 5px;
    }
  }
`;

export const StyledFormControlLabel = styled(FormControlLabel)<{ $error?: boolean }>`
  .MuiFormControlLabel-root {
    margin-left: 0;
  }

  .MuiFormControlLabel-labelPlacementEnd {
    margin-left: 0;
  }

  & .MuiFormControlLabel-label {
    font-size: 12px;
    color: ${({ $error }) => $error && COLORS.red} !important;
  }

  & .MuiFormControlLabel-label.Mui-disabled {
    color: ${COLORS["neutral/300"]} !important;
  }

  & .MuiCheckbox-root {
    padding: 0 5px 0 0;
  }

  & .MuiCheckbox-root.Mui-checked {
    color: ${COLORS["orange"]};
  }

  & .MuiCheckbox-root.Mui-disabled {
    color: ${COLORS["neutral/300"]};
  }
`;

export const StyledCheckbox = styled(Checkbox)<{ $error?: boolean }>`
  & .Mui-checked {
    color: black;
  }

  & .MuiSvgIcon-root {
    fill: ${({ $error }) => $error && COLORS.red} !important;
  }
`;
